import React from 'react';
import Hero from '../components/Hero';
import Navbar from '../components/Navbar';
import CountdownTimer from '../components/CountdownTimer';
import OurStory from '../components/OurStory';
import EventDetails from '../components/EventDetails';
import WeddingParty from '../components/WeddingParty';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
export function MainSite() {
  return <div className="font-sans text-gray-800 bg-ivory" data-id="element-276">
      <Navbar data-id="element-277" />
      <Hero data-id="element-278" />
      <CountdownTimer data-id="element-279" />
      <OurStory data-id="element-280" />
      <EventDetails data-id="element-281" />
      <WeddingParty data-id="element-282" />
      <Gallery data-id="element-283" />
      <Footer data-id="element-284" />
    </div>;
}